import { bt } from '@/i18n/bookingI18n';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const validators = [
  (form, lang) => (form.duration ? {} : { duration: bt(lang, 'errDuration') }),
  (form, lang) => {
    const e = {};
    if (!form.date) e.date = bt(lang, 'errDate');
    if (!form.time) e.time = bt(lang, 'errTime');
    Object.assign(e, validateStop(form, 'pickup', lang), validateStop(form, 'dropoff', lang));
    return e;
  },
  (form, lang) => {
    const e = {};
    if (!form.passengers) e.passengers = bt(lang, 'errPassengers');
    if (!form.vehicle) e.vehicle = bt(lang, 'errVehicle');
    return e;
  },
  (form, lang) => {
    const e = {};
    if (!form.name.trim()) e.name = bt(lang, 'errName');
    if (!EMAIL_RE.test(form.email.trim())) e.email = bt(lang, 'errEmail');
    if (!form.phone.trim()) e.phone = bt(lang, 'errPhone');
    return e;
  },
];

function validateStop(form, kind, lang) {
  const type = form[`${kind}Type`];
  if (type === 'airport' && !form[`${kind}Airport`]) return { [`${kind}Airport`]: bt(lang, 'errSelectTerminal') };
  if (type === 'location' && !form[`${kind}Location`].trim()) return { [`${kind}Location`]: bt(lang, kind === 'pickup' ? 'errPickupAddr' : 'errDropoffAddr') };
  return {};
}

export function validateStep(step, form, lang = 'en') {
  const validate = validators[step];
  return validate ? validate(form, lang) : {};
}

export function buildBookingPayload(form, price) {
  return {
    service_type: 'chauffeur',
    duration: form.duration, date: form.date ? form.date.toISOString() : '', time: form.time,
    pickup_type: form.pickupType, pickup_location: form.pickupType === 'airport' ? form.pickupAirport : form.pickupLocation,
    dropoff_type: form.dropoffType, dropoff_location: form.dropoffType === 'airport' ? form.dropoffAirport : form.dropoffLocation,
    passengers: form.passengers, vehicle: form.vehicle, price,
    name: form.name, email: form.email, phone: form.phone, notes: form.notes,
  };
}
